import React from 'react';
import PropTypes from 'prop-types';
import DashboardCard from './DashboardCard';

/**
 * Title row, main body, and optional footer (muted helper at bottom).
 * Uses natural card height (no h-100) so paired columns need not match height.
 */
export default function DashboardFeatureCard({
  className = '',
  accent = null,
  padding,
  title,
  titleAside = null,
  footer = null,
  children = null,
}) {
  const footerNode =
    footer == null
      ? null
      : typeof footer === 'string'
        ? <p className="text-muted small mb-0">{footer}</p>
        : footer;

  return (
    <DashboardCard
      className={className}
      accent={accent}
      padding={padding}
      fillRowHeight={false}
    >
      <div className="d-flex flex-column">
        <div className="d-flex justify-content-between align-items-start gap-3 mb-3">
          <h6 className="fw-semibold mb-0">{title}</h6>
          {titleAside ? <div className="flex-shrink-0">{titleAside}</div> : null}
        </div>
        <div className="flex-grow-1 min-w-0">{children}</div>
        {footerNode != null ? <div className="mt-auto pt-3">{footerNode}</div> : null}
      </div>
    </DashboardCard>
  );
}

DashboardFeatureCard.propTypes = {
  className: PropTypes.string,
  accent: PropTypes.string,
  padding: PropTypes.string,
  title: PropTypes.node.isRequired,
  titleAside: PropTypes.node,
  footer: PropTypes.node,
  children: PropTypes.node,
};
